<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <g fill="none" fill-rule="evenodd">
      <rect width="14" height="18"></rect>
      <path
        d="M12.0187784,5.32138771 C12.4774933,4.88750173 13.2066434,4.89370691 13.6575897,5.33533425 C14.108536,5.77696159 14.1148721,6.49104363 13.6718306,6.94027894 L7.82652606,12.6647882 C7.37000795,13.1117373 6.62999205,13.1117373 6.17347394,12.6647882 L0.328169447,6.94027894 C-0.114872145,6.49104363 -0.108536027,5.77696159 0.342410275,5.33533425 C0.793356576,4.89370691 1.52250674,4.88750173 1.98122156,5.32138771 L7,10.2364514 L12.0187784,5.32138771 Z"
        :fill="fillColor"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fillColor: {
      type: String,
      default() {
        return "#2e5276";
      }
    },
    width: {
      type: String,
      default() {
        return "18";
      }
    },
    height: {
      type: String,
      default() {
        return "18";
      }
    }
  }
};
</script>
